<template>
	<vs-checkbox v-model="localState" :color="color" :vs-value="vsValue" :icon-pack="icon[0]" :icon="'fa-' + icon[1]">
		<slot></slot>
	</vs-checkbox>
</template>

<script>
export default{
	name: 'vx-checkbox',
	props: {
		value: {
			type: String | Boolean | Array,
		},
		color: {
			type: String,
			default: 'primary',
		},
		vsValue: {
			type: String,
		},
		icon: {
			type: Array,
			default: () => ['fas', 'check'],
		},
	},
	computed: {
		localState: {
			get() { return this.value },
			set(localState) { this.$emit('input', localState) }
		}
	}
}
</script>
